import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Title = styled(Typography)({
  fontWeight: '500',
  fontSize: '18px',
  lineHeight: '27px',
  color: '#657787',
})
